import { render, staticRenderFns } from "./CommandBar.vue?vue&type=template&id=50d7cd32&scoped=true&"
import script from "./CommandBar.vue?vue&type=script&lang=js&"
export * from "./CommandBar.vue?vue&type=script&lang=js&"
import style0 from "./CommandBar.vue?vue&type=style&index=0&id=50d7cd32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d7cd32",
  null
  
)

export default component.exports